// Data constants for the Jashvi Energy site
export const COMPANY = {
  name: "Jashvi Energy",
  fullName: "Jashvi Energy Solutions",
  logo: "https://customer-assets.emergentagent.com/job_solar-install-pro-9/artifacts/9zqv1zxg_Jashvi%20logo%20.png",
  tagline: "Sun-Powered. Future-Proofed.",
  subline:
    "Premium rooftop solar installations across Karnataka — engineered with Tier 1 components, delivered in 7 days, backed by a 30-strong in-house team.",
  phones: ["9740888373", "9980570506"],
  email: "sales@jashvienergy.com",
  address:
    "24, Manorayana Palya, 3rd Cross, Main Rd, Sultan Palya, Bengaluru, Karnataka 560032",
  serviceArea: "All over Karnataka",
  yearsExperience: "3.5",
  teamSize: 30,
};

export const STATS = [
  { value: "3.5+", label: "Years of expertise" },
  { value: "30", label: "In-house specialists" },
  { value: "160+", label: "Installations delivered" },
  { value: "100%", label: "Karnataka coverage" },
];

export const INSTALLATIONS = [
  {
    type: "Residential",
    count: 134,
    image:
      "https://static.prod-images.emergentagent.com/jobs/cf5f6853-f98e-4b62-88f9-0d03d2ce960b/images/65bf23021538cb9193bd8cec3e2a95af711e39f7fc606ec327d6bf18ae0f71d1.png",
    blurb:
      "Villas, apartments and bungalows powered by elegant rooftop arrays sized 3 kW to 25 kW.",
  },
  {
    type: "Commercial",
    count: 10,
    image:
      "https://images.pexels.com/photos/35454189/pexels-photo-35454189.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    blurb:
      "Offices, warehouses and retail chains running on 25 kW – 250 kW grid-tied solutions with rapid payback.",
  },
  {
    type: "Industrial",
    count: 3,
    image:
      "https://static.prod-images.emergentagent.com/jobs/cf5f6853-f98e-4b62-88f9-0d03d2ce960b/images/2a1df4388d0fd4d4869a1738a04f5ec68aeb58e222860d8763125fd35bf3834f.png",
    blurb:
      "Megawatt-class plants engineered for factories with custom structures and continuous monitoring.",
  },
];

export const WHY_US = [
  {
    icon: "ShieldCheck",
    title: "Tier 1 Panels",
    body: "Industry-leading modules with a 30-year linear power warranty — proven Bloomberg-rated brands only.",
  },
  {
    icon: "Cpu",
    title: "Tier 1 Inverters",
    body: "On-grid string inverters from Waaree, Goodwe, Deye & Solis — 10-year manufacturer warranty.",
  },
  {
    icon: "Wrench",
    title: "Quarterly Maintenance",
    body: "Complimentary cleaning, thermography and performance audits every 3 months for the first 3 years.",
  },
  {
    icon: "Layers",
    title: "Custom Structures",
    body: "Low-rise, mid-rise, high-rise and flush-mount — galvanised structures engineered for your roof.",
  },
  {
    icon: "Headphones",
    title: "24/7 Customer Support",
    body: "Direct line to engineers, monitoring dashboards and rapid on-site response across Karnataka.",
  },
  {
    icon: "Zap",
    title: "7-Day Handover",
    body: "From design freeze to commissioning — most residential systems are switched on within a week.",
  },
];

export const BRAND_CATEGORIES = [
  {
    title: "On-Grid Inverters",
    brands: [
      { name: "Waaree", logo: "https://logo.clearbit.com/waaree.com" },
      { name: "Goodwe", logo: "https://logo.clearbit.com/goodwe.com" },
      { name: "Deye", logo: "https://logo.clearbit.com/deyeinverter.com" },
      { name: "Solis", logo: "https://logo.clearbit.com/solisinverters.com" },
    ],
  },
  {
    title: "Solar Panels",
    brands: [
      { name: "Waaree", logo: "https://logo.clearbit.com/waaree.com" },
      { name: "Satvik", logo: "https://logo.clearbit.com/satvik.solar" },
      { name: "EMMVEE", logo: "https://logo.clearbit.com/emmvee.com" },
      { name: "Goldi Solar", logo: "https://logo.clearbit.com/goldisolar.com" },
    ],
  },
  {
    title: "Mounting & Cabling",
    brands: [
      { name: "HILTI", logo: "https://logo.clearbit.com/hilti.com" },
      { name: "Polycab", logo: "https://logo.clearbit.com/polycab.com" },
    ],
  },
  {
    title: "ACDB / DCDB",
    brands: [
      { name: "Schneider Electric", logo: "https://logo.clearbit.com/se.com" },
      { name: "ABB", logo: "https://logo.clearbit.com/abb.com" },
    ],
  },
];

export const ALL_BRANDS = BRAND_CATEGORIES.flatMap((c) => c.brands);

export const PROPRIETOR = {
  name: "Shalini Ashwath",
  role: "Founder & Proprietor",
  portrait:
    "https://customer-assets.emergentagent.com/job_solar-install-pro-9/artifacts/yc16veeg_Shalini%20Image.jpeg",
  bio: [
    "Founder of Evergreen Edulife Pvt Ltd with a decade of leadership experience at TIME and RYTHM, Shalini brings rigour, empathy and operational discipline to every project Jashvi Energy delivers.",
    "Under her stewardship, the company has scaled to 30 in-house specialists and 160+ installations across Karnataka — combining premium engineering with the warmth of a family-run business.",
  ],
};

export const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/cf5f6853-f98e-4b62-88f9-0d03d2ce960b/images/7078776b7c4e6322e625094aaad6de2a00e92e647260dd8c1613950ec19dba98.png";
